import { Form, Input, Select, Row, Col, Button } from 'antd';
import React, { useEffect, useState } from 'react';

const GilMultiRow = ({
    label,
    labelColSpan,
    name,
    options,
    defaultValue,
    form,
    countLabel,
    children,
    required,
    errorMessage,
    data,
    disabled,
    rowCountReadOnly
}) => {
    const [parentValue, setParentValue] = useState('');
    const rowCount = Form.useWatch(`${name}_row_count`, form);
    const [rowLength, setRowLength] = useState();

    useEffect(() => {
        form.setFieldsValue({ [name]: defaultValue });
        if (defaultValue === 'yes') {
            setParentValue(defaultValue);
            form.setFieldsValue({ [`${name}_row_count`]: data[`${name}_row_count`] });
            setRowLength(data[`${name}_row_count`]);
            if (data[`${name}CountValue`]) {
                Object.keys(data[`${name}CountValue`]).forEach((x) => {
                    form.setFieldsValue({ [x]: data[`${name}CountValue`][x] });
                })
            }

        }
    }, []);

    return (
        <div>
            <Form.Item
                name={name}
                label={label}
                labelCol={{ span: labelColSpan ? labelColSpan : 8 }}
                rules={[
                    {
                        required: required,
                        message: errorMessage,
                    },
                ]}
            >
                <Select
                    disabled={disabled}
                    onChange={(value) => {
                        setParentValue(value);
                        if (value === 'no') {
                            setRowLength(0);
                            form.setFieldsValue({ [`${name}_row_count`]: '' })
                        }
                        // setShowGilChild(value === 'yes' ? true : false)
                    }}
                    options={options} />
            </Form.Item>
            {
                parentValue === 'yes' && (
                    <Form.Item label={countLabel} name={`${name}_row_count`} labelCol={{ span: data.countLabelColSpan ? data.countLabelColSpan : 8 }}>
                        <Input 
                        disabled={rowCountReadOnly}
                        type='number' suffix={
                            <Button disabled={rowCountReadOnly} type="link" onClick={() => setRowLength(rowCount)}>Submit</Button>
                        } />
                    </Form.Item>
                )
            }

            <>
                {
                    Array.from({ length: parseInt(rowLength) }).map((_, i) => (
                        <Row>
                            {
                                children.map((y, j) => (
                                    <Col span={y.colSize || 8}>
                                        <Form.Item
                                            labelCol={{ span: y.labelColSpan ? y.labelColSpan : 8 }}
                                            label={y.label + (i + 1)} name={y.data_index + (i + 1)}>
                                            <Input disabled={y.readOnly} type={j === 0 ? "text" : 'number'} />
                                        </Form.Item>
                                    </Col>
                                ))
                            }
                            {/* <Col span={8}>
                                <Form.Item
                                    labelCol={24}
                                    label={"Integer 1 - " + (i + 1)} name={"int1-" + (i + 1)}>
                                    <Input type="number" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    labelCol={24}
                                    label={"Integer 2 - " + (i + 1)} name={"int2-" + (i + 1)}>
                                    <Input type='number' />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    labelCol={24}
                                    label={"Remark - " + (i + 1)} name={"rmrk" + (i + 1)}>
                                    <Input />
                                </Form.Item>
                            </Col> */}
                        </Row>
                    ))
                }
            </>
        </div>
    )
};


export default GilMultiRow;